import React from 'react';
import Config from '../MonitoringDevices/Config/Config';

function Settings() {
  return (<Config></Config>)

}

export default Settings;
